import React from "react"
import { useConsultantDetailsContext } from "../ConsultantDetails"
import { IGetDetailsConsultant } from "../core/_models"
import { useConsultant } from "../../core/useConsultant"
import { toast } from "react-toastify"

const ConsultantDetailsAlerteInstructionsConnexionNotSent = () => {
     const { detailsQuery } = useConsultantDetailsContext()

     const data = detailsQuery.data as IGetDetailsConsultant
     const consultant = data.consultant!

     const { accountEnvoyerInstructionsConnexion } = useConsultant()

     function handleEnvoyerInstructionsConnexion() {
          const successCallback = () => toast.success("Instructions envoyées avec succès.")

          accountEnvoyerInstructionsConnexion(
               consultant,
               () => {},
               () => successCallback()
          )
     }

     return (
          <>
               <div className="alert alert-warning text-gray-700 fw-bold">
                    <div className="fs-5 mb-2 d-flex align-items-center">
                         <i className="fas fa-envelope-open-text me-2 text-warning"></i>
                         <span className="text-warning">Instructions de connexion</span>
                    </div>

                    <div className={"mb-1"}>
                         Ce collaborateur ne s’est pas encore connecté à la plateforme. Vous pouvez lui envoyer ses instructions de connexion :
                         <span className="text-primary ms-1 text-pulse cursor-pointer text-hover-dark" onClick={() => handleEnvoyerInstructionsConnexion()}>
                              Envoyer les instructions <span className="fas fa-paper-plane" />
                         </span>
                    </div>

                    <div>Cette alerte disparaîtra une fois qu'il se sera connecté à son espace.</div>
               </div>
          </>
     )
}

export default ConsultantDetailsAlerteInstructionsConnexionNotSent
